import React, {useEffect, useState} from 'react';
import {ErrorBoundary} from "react-error-boundary";
import FallbackComponent from "root/FallbackComponent";
import './Footer.scss';
import { Link } from "react-router-dom";

const Footer = (props) =>
{
    const url = '/home/about_us' ;

    const year = new Date().getFullYear() ;

    return (
        <ErrorBoundary  FallbackComponent={FallbackComponent}>
           <div className='footer-row-top'>
               <p>© 2022-{year} - Seven 360 in partnership with Northumberland County Council</p>
               <div><Link to={url}>About Seven360</Link></div>
           </div>
        </ErrorBoundary>
    )
}

export default Footer;
